export default __webpack_public_path__ + "static/media/neworder.9af8b607.mp3";